import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import ListWrapper from '../listWrapper';
import ListHeader from '../listHeader';
import ListRenderState from '../../../services/enums/listRenderState';
import WindowedList from '../../portal/windowedList';

export default class ListMainWrapper extends Component {

    render() {

        if (this.props.items && this.props.items.length > 0) {
            
            status = ListRenderState.shouldRenderList;
        }
        else if(this.props.items) {

            status = ListRenderState.shouldRenderEmptyMessage;
        }
        else {

            status = ListRenderState.shouldNotRender;
        }
        
        const rowCount = this.props.items ? this.props.items.length : 0;

        return (
            <div>
                <ListWrapper 
                    {...this.props}
                    header={<ListHeader
                        translations={this.props.translations}
                        {...this.props}
                    />}
                    listRenderState={parseInt(status)}
                />
                <WindowedList
                    rowCount={rowCount}
                    rowHeight={this.props.rowHeight}
                    rowRenderer={this.props.rowRenderer}
                    height={this.props.scrollsHeight || '30vh'}
                />
            </div>
        );
    }
}
